import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  selectDependentGuardianList,
  selectDependentGuardianListLoading,
} from '../../../redux/dependentForm/selectors';
import { myProfileRedirectActions } from '../../../redux/profiles/my-profile-redirect';
import * as sendMessage from '../../../redux/chatConnection/sendMessage';

const mapStateToProps = state => ({
  guardianList: selectDependentGuardianList(state),
  loading: selectDependentGuardianListLoading(state),
});
const mapDispatchToProps = {
  redirectToProfile: myProfileRedirectActions.goToProfile,
  sendMessage: sendMessage.actions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentExistingUser/enhance.js